/** @graphql cc **/

import gql from 'graphql-tag';

/*
  GraphQLPageStatus comes from monolith and PTGraphQLPageStatus comes
  from cc-page-tree and they need to be separate due to a Braid bug:
  https://product-fabric.atlassian.net/browse/SCALE-4686
*/
export const PageTreeFollowingItemsQuery = gql`
	query PageTreeFollowingItemsQuery(
		$spaceKey: String!
		$ptStatuses: [PTGraphQLPageStatus]
		$contentId: ID!
		$paginationLimit: Int
		$isSuperAdmin: Boolean!
	) {
		currentPage: ptpage(
			id: $contentId
			spaceKey: $spaceKey
			pageTree: $paginationLimit
			status: $ptStatuses
			enablePaging: true
		) {
			id
			title
			status
			hasChildren
			blank
			hasRestrictions @include(if: $isSuperAdmin)
			hasInheritedRestrictions @include(if: $isSuperAdmin)
			type
			subType
			links {
				webui
			}
			properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
				nodes {
					id
					key
					value
					version {
						number
					}
				}
			}
			nearestAncestors {
				pageInfo {
					hasNextPage
				}
				nodes {
					followingSiblings {
						nodes {
							id
							title
							status
							hasChildren
							blank
							hasRestrictions @include(if: $isSuperAdmin)
							hasInheritedRestrictions @include(if: $isSuperAdmin)
							type
							subType
							links {
								webui
							}
							properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
								nodes {
									id
									key
									value
									version {
										number
									}
								}
							}
						}
						pageInfo {
							hasNextPage
						}
					}
				}
			}
			followingSiblings {
				nodes {
					id
					title
					status
					hasChildren
					blank
					hasRestrictions @include(if: $isSuperAdmin)
					hasInheritedRestrictions @include(if: $isSuperAdmin)
					type
					subType
					links {
						webui
					}
					properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
						nodes {
							id
							key
							value
							version {
								number
							}
						}
					}
				}
				pageInfo {
					hasNextPage
				}
			}
		}
	}
`;
